import React from 'react';
import {
  Drawer,
  DrawerContainer,
  DrawerContent,
} from '@noths/polaris-client-ribbons-design-system';
import { css } from 'styled-components';

import * as S from '../PhotoPicker.styles';

const PANEL_CONTENT_STYLES = css`
  max-width: 450px;
  background: #ffffff;
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.1);
`;

interface Props {
  cancelLabel: string;
  children: React.ReactNode;
  confirmDisabled?: boolean;
  confirmLabel: string;
  describedById?: string;
  heading: string;
  isOpen: boolean;
  max?: number;
  onCancel: () => void;
  onConfirm: () => void;
  requirements?: string[];
  subDescription: string;
}

export function PhotoPickerDrawer({
  cancelLabel,
  children,
  confirmDisabled,
  confirmLabel,
  describedById,
  heading,
  isOpen,
  max,
  onCancel,
  onConfirm,
  requirements,
  subDescription,
}: Props) {
  return (
    <Drawer
      contentContainerStyles={PANEL_CONTENT_STYLES}
      contentLabel={heading}
      describedBy={describedById}
      isOpen={isOpen}
      onOverlayClick={onCancel}
      onRequestClose={onCancel}
      transitionFrom="right"
    >
      <DrawerContainer>
        <DrawerContent>
          <S.DrawerBody>
            <S.DrawerOptionContainer>
              <S.DrawerHeading>{heading}</S.DrawerHeading>
              <S.DrawerSubDescription>
                {subDescription}
                {max != null ? ` (Max ${max})` : ''}
              </S.DrawerSubDescription>
              {requirements && requirements.length > 0 && (
                <S.DrawerRequirements>
                  {requirements.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </S.DrawerRequirements>
              )}
            </S.DrawerOptionContainer>
            {children}
          </S.DrawerBody>
        </DrawerContent>
        <S.Footer>
          <S.FooterButton $variant="secondary" onClick={onCancel} type="button">
            {cancelLabel}
          </S.FooterButton>
          <S.FooterButton
            $variant="primary"
            disabled={confirmDisabled}
            onClick={onConfirm}
            type="button"
          >
            {confirmLabel}
          </S.FooterButton>
        </S.Footer>
      </DrawerContainer>
    </Drawer>
  );
}
